module.exports = __webpack_public_path__ + "static/the-score-takes-care-of-itself-0327bb9bf3a405d6640d8c8dd82e3636.jpg";